import axios from "axios";
import React, { useEffect, useReducer, useState } from "react";
import Reducer from "../utilities/Reducer";
import { useNavigate, useParams } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";
import getTicketDescription from "../utilities/ticketDescriptions";
import { getTicketOldPrice, getTicketValidityDate } from "../utilities/ticketPricing";

import addIcon from "../images/icons/add.png";
import removeIcon from "../images/icons//remove.png";

import "../css/style.css";

const Home = () => {
    const [eventId, setEventId] = useState("");
    const [orderId, setOrderId] = useState("");
    const [remarks, setRemarks] = useState({});
    const [eventInfo, setEventInfo] = useState({});
    const [ticketTypes, setTicketTypes] = useState([]);
    const [selectedTicketTypes, setSelectedTicketTypes] = useState([]);
    const [promoCode, setPromoCode] = useState("");
    const [promoError, setPromoError] = useState("");
    const [promoSuccess, setPromoSuccess] = useState("");
    const [isNotValid, setIsNotValid] = useState(true);
    const [loading, setLoading] = useState(true);
    const [token, setToken] = useState(sessionStorage.getItem("token"));
    const [unlockTicketTypes, setUnlockTicketTypes] = useState([]);
    const [customCheckboxText, setCustomCheckboxText] = useState(false);
    const [ticketTypeMappings, setTicketTypeMappings] = useState(null);

    const [selectedIam, setSelectedIam] = useState("");


    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // fetching resources
    const [resources, setResources] = useState({});

    const { language } = useParams();

    const [languageInfo, dispatch] = useReducer(Reducer, {
        id: 0,
        language: language
    });

    // Format price with Swiss thousand separator (apostrophe)
    const formatPrice = (price) => {
        if (price == null) return "";
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    };

    // Get quantity for a specific ticket type
    const getQuantity = (ticketTypeId) => {
        const found = selectedTicketTypes.find(t => t.ticketTypeId === ticketTypeId);
        return found ? found.quantity : 0;
    };

    // Handle quantity change with +/- buttons
    const onQuantityChange = (ticketTypeId, delta, max) => {
        setSelectedTicketTypes(prev => {
            const existing = prev.find(t => t.ticketTypeId === ticketTypeId);
            let quantity = existing ? parseInt(existing.quantity) : 0;
            quantity += delta;
            if (quantity < 0) quantity = 0;
            if (quantity > max) quantity = max;

            const updated = prev.filter(t => t.ticketTypeId !== ticketTypeId);
            if (quantity > 0) {
                updated.push({ ticketTypeId, quantity });
            }

            // Update validation
            const total = updated.reduce((sum, t) => sum + t.quantity, 0);
            setIsNotValid(total === 0);

            return updated;
        });
    };

    useEffect(() => {
        loadToken();
    }, []); //only on first page load

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    const loadToken = () => {
        axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;

            setToken(res.data);
            sessionStorage.setItem("token", res.data);

            requestFormSettings();
        });
    };

    const requestFormSettings = () => {
        axios.get(`form/formsettings`).then((res) => {
            setTicketTypeMappings(res.data.ticketTypeMappings);
            setEventId(res.data.eventId);
            startOrder(res.data.posId);
        });
    }


    useEffect(() => {

        axios.defaults.headers.common["Authorization"] = "Bearer " + token;

        if (orderId !== "" && eventId !== "") {
            //setLoading(true);

            async function loadEvent() {
                var event = await requestEvent();

                if (event == null) return;

                sessionStorage.setItem("SwissFinanceWeekEvent", JSON.stringify(event));

                if (event.remarks) {
                    setRemarks(JSON.parse(event.remarks))
                }

                var eventInfos = await requestEventInfo(event.id);

                // instead of setting it as an object, we were adding the object to an array!
                setEventInfo(eventInfos.eventInfos.find((infos) => infos.languageId === languageInfo.id));

                var ticketTypesOfEvent = await requestTicketTypes();
                ticketTypesOfEvent = ticketTypesOfEvent.ticketTypes.sort((a, b) => (a.sortOrder > b.sortOrder) ? 1 : ((b.sortOrder > a.sortOrder) ? -1 : 0)); //sort

                var availabilities = ticketTypesOfEvent.map(async (tt) => {
                    let availability = await requestTicketTypeNumberOfAvailableTickets(tt.id, ""); //get availability
                    tt.availability = availability;
                });

                await Promise.all(availabilities);

                var infos = ticketTypesOfEvent.map(async (tt) => {
                    var ticketTypeInfos = await requestTicketTypeInfo(tt.id);
                    tt.info = ticketTypeInfos.ticketTypeInfos[0];
                });

                await Promise.all(infos);

                setTicketTypes(ticketTypesOfEvent);
            }

            loadEvent();

            //setLoading(false);
        }

    }, [orderId, eventId]); //everytime orderId is changed

    const requestResources = () => {
        axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setSelectedIam(res.data.translation.HomeIam1)
                setResources(res.data.translation);
            })
            .catch((error) => console.log(error.response.data));
    };

    const startOrder = (posId) => {
        let order = {
            affiliateShopId: null,
            currency: "CHF",
            tenantId: 1,
            pointOfSaleId: posId,
            abbreviation: "",
            paymentType: 1,
            deliveryType: 1,
        };

        axios
            .post(`${baseUrl}/ShopBasket/Order`, order)
            .then((res) => {
                sessionStorage.setItem("OrderId", res.data.id);

                setOrderId(res.data.id);
            })
            .catch((error) => console.error(error.response.data));
    };

    const requestEvent = async () => {
        var response = await axios.get(`${baseUrl}/Event/${eventId}`);
        return response.data;
    };

    const requestEventInfo = async () => {
        var response = await axios.get(`${baseUrl}/Event/${eventId}/Infos`);
        return response.data;
    };

    const requestTicketTypes = async () => {
        var response = await axios.get(`${baseUrl}/Event/${eventId}/TicketTypes`);
        return response.data;
    };

    const requestTicketTypeNumberOfAvailableTickets = async (ticketTypeId, code) => {

        if (ticketTypeId == null || code == null) return;

        let url = `${baseUrl}/TicketType/${ticketTypeId}/Availability?orderId=${orderId}`;

        if (code != "") {
            url = `${baseUrl}/TicketType/${ticketTypeId}/Availability?orderId=${orderId}&promotionCode=${promoCode}`;
        }

        var response = await axios.get(url);
        return response.data;
    };

    const getTicketTypePriceForOrder = async (ticketTypeId, code) => {

        if (ticketTypeId == null || code == null) return;

        let url = `${baseUrl}/ShopBasket/Order/${orderId}/TicketType/${ticketTypeId}/Price`;

        if (code != "") {
            url += `?promotionCode=${promoCode}`;
        }

        var response = await axios.get(url);
        return response.data;
    };

    const requestTicketTypeInfo = async (ticketTypeId) => {
        var response = await axios.get(`${baseUrl}/TicketType/${ticketTypeId}/Infos`);
        return response.data;
    };

    // Helper function to check if a ticket type should be displayed
    const shouldDisplayTicketType = (ticketTypeId) => {
        if (!ticketTypeMappings || !selectedIam) return false;

        // Get the IAM key from the selected value
        let iamKey = "";
        if (selectedIam === resources.HomeIam1) iamKey = "HomeIam1";
        else if (selectedIam === resources.HomeIam2) iamKey = "HomeIam2";
        else if (selectedIam === resources.HomeIam3) iamKey = "HomeIam3";
        else if (selectedIam === resources.HomeIam4) iamKey = "HomeIam4";

        const hasPromo = promoSuccess !== "";
        const ticketId = parseInt(ticketTypeId);

        if (hasPromo) {
            // Get all promo tickets for current IAM
            const promoMappings = ticketTypeMappings.filter(
                m => m.iamKey === iamKey && m.hasPromoCode === true
            );
            const promoTicketsForThisIam = promoMappings.flatMap(m => m.ticketTypeIds);

            // Get unlocked tickets for current IAM (intersection of unlocked and configured promo tickets)
            const unlockedForThisIam = promoTicketsForThisIam.filter(id =>
                unlockTicketTypes.includes(id)
            );

            if (unlockedForThisIam.length > 0) {
                // We have unlocked tickets for this IAM, show ONLY those
                return unlockedForThisIam.includes(ticketId);
            } else {
                // No unlocked tickets for this IAM, show normal tickets
                const normalMappings = ticketTypeMappings.filter(
                    m => m.iamKey === iamKey && m.hasPromoCode === false
                );
                return normalMappings.some(m => m.ticketTypeIds.includes(ticketId));
            }
        } else {
            // No promo active, show normal tickets only
            const mappings = ticketTypeMappings.filter(
                m => m.iamKey === iamKey && m.hasPromoCode === false
            );
            return mappings.some(m => m.ticketTypeIds.includes(ticketId));
        }
    };

    const mapTicketsTypes = () => {
        let hasVisibleTickets = false;

        const ticketElements = ticketTypes?.length > 0 && ticketTypes.map((tt, index) => {
            if (tt.isActive && tt.info && tt.availability && tt.availability.status === 0) {
                if (shouldDisplayTicketType(tt.id)) {
                    hasVisibleTickets = true;
                    const description = getTicketDescription(tt.id);
                    const currentQuantity = getQuantity(tt.id);
                    const isCurrentTicketValid = currentQuantity > 0;

                    // Get old price and validity date information
                    const oldPrice = getTicketOldPrice(tt.id);
                    const validityDate = getTicketValidityDate(tt.id);

                    return (
                        <div key={tt.id} className="col-md-4 mb-4">
                            <div className="ticket-card">
                                <div className="ticket-card-name ps-3 pe-3 text-center d-flex flex-column align-items-center justify-content-center">
                                    <span>{tt.info.name}</span>
                                    {validityDate && (
                                        <small className="bold" style={{ color: '#d9534f', fontSize: '0.7em' }}>
                                            {validityDate}
                                        </small>
                                    )}
                                </div>
                                <div className="ticket-card-price text-center">
                                    {oldPrice && oldPrice > tt.price && (
                                        <>
                                            <span className="bold me-2" style={{ textDecoration: 'line-through' }}>{tt.currency} {formatPrice(oldPrice)}</span> 
                                        </>
                                    )}
                                    <span className="bold">{tt.price === 0 ? "FREE" : `${tt.currency} ${formatPrice(tt.price)}`}</span><br />
                                    <span>excl. VAT</span>
                                </div>
                                <div className="ticket-card-body">
                                    {description &&
                                        <div className="ticket-card-description ps-3 pe-3 pt-3 pb-3" dangerouslySetInnerHTML={{ __html: description }} />
                                    }
                                    <div className="mt-3 ticket-card-quantity">
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                            <button
                                                type="button"
                                                onClick={() => onQuantityChange(tt.id, -1, tt.availability?.availableTickets)}
                                                style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 0 }}
                                            >
                                                <img src={addIcon} alt="Add" style={{ width: '25px', height: '25px' }} />
                                            </button>
                                            <span style={{ minWidth: '40px', textAlign: 'center', fontSize: '18px' }}>
                                                {currentQuantity}
                                            </span>
                                            <button
                                                type="button"
                                                onClick={() => onQuantityChange(tt.id, 1, tt.availability?.availableTickets)}
                                                style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 0 }}
                                            >
                                                <img src={removeIcon} alt="Remove" style={{ width: '25px', height: '25px' }} />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="mt-3 pb-3 ps-3 pe-3">
                                        <button
                                            className="btn btn-custom form-control"
                                            onClick={() => onSubmitSingleTicket(tt.id)}
                                            disabled={!isCurrentTicketValid || checkboxIsNotValid}
                                        >
                                            {resources.HomeAddTobasket}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                }
            }
            return null;
        });

        if (!hasVisibleTickets) {
            return null;
        }

        return (
            <>
                <div className="row mt-5 mb-2">
                    <div className="col-md-12">
                        <span className="title-blue">Choose your Pass</span>
                    </div>
                </div>
                <div className="row">
                    {ticketElements}
                </div>
            </>
        );
    };

    const applyPromotionCode = async () => {
        setLoading(true);
        setPromoError("");
        setPromoSuccess("");

        try {
            var result = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${promoCode}`);

            if (result.status === 200) {
                setPromoSuccess(resources?.PromocodeSuccess || "Promo code successfully applied!");
                setUnlockTicketTypes(result.data.unlockedTicketTypes);

                if (result.data.unlockedTicketTypes.length === 0) return;

                var t = result.data.unlockedTicketTypes.map(async (tt) => {

                    var ticketType = ticketTypes.find(ticketType => ticketType.id === tt);

                    if (ticketType) {

                        let availability = await requestTicketTypeNumberOfAvailableTickets(tt, promoCode);
                        let price = await getTicketTypePriceForOrder(tt, promoCode);

                        //:(
                        if (ticketType.id === 879208) price = 240;

                        ticketType.price = price;
                        ticketType.availability = availability;
                    }
                });

                await Promise.all(t);

                setPromoError("");
                setTicketTypes(ticketTypes);
            }
        } catch (error) {
            console.error(error.response?.data || error);
            setPromoError(resources?.PromotionError || "Invalid promo code. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const addTicketToBasket = () => {

        let addTicketTypes = [];

        addTicketTypes = selectedTicketTypes.filter((stt) => stt.quantity !== "0");

        addTicketTypes.map((tt) => {
            if (unlockTicketTypes.includes(tt.ticketTypeId)) {
                tt.promotionCode = promoCode;
            }
        });

        axios
            .post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                ticketsToAdd: addTicketTypes,

            })
            .then(() => {
                let addressBody = {
                    code1: selectedIam,
                };

                // Store addressBody in localStorage for later use
                localStorage.setItem("addressBodySwissFitechWeek", JSON.stringify(addressBody));

                navigate(`/${language}/shipping`);
            })
            .catch((error) => {
                console.error(error.response.data);
            });
    };

    const onSubmitSingleTicket = (ticketTypeId) => {
        sessionStorage.setItem("isCustomCheckboxChecked", customCheckboxText);

        // Filter to only include the specific ticket type that was clicked
        const specificTicket = selectedTicketTypes.find(t => t.ticketTypeId === ticketTypeId);
        if (!specificTicket) return;

        let addTicketTypes = [specificTicket];

        if (unlockTicketTypes.includes(ticketTypeId)) {
            addTicketTypes[0].promotionCode = promoCode;
        }

        axios
            .post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                ticketsToAdd: addTicketTypes,
            })
            .then(() => {
                let addressBody = {
                    code1: selectedIam,
                };

                // Store addressBody in localStorage for later use
                localStorage.setItem("addressBodySwissFitechWeek", JSON.stringify(addressBody));

                navigate(`/${language}/shipping`);
            })
            .catch((error) => {
                console.error(error.response.data);
            });
    };

    const onSubmit = () => {
        sessionStorage.setItem("isCustomCheckboxChecked", customCheckboxText);
        addTicketToBasket();
    };

    let checkboxIsNotValid = false;
    let checkboxOptional = remarks?.CustomCheckboxOptional ?? false;

    if (remarks?.CustomCheckboxText) {
        if (!customCheckboxText && !checkboxOptional) {
            checkboxIsNotValid = true
        } else {
            checkboxIsNotValid = false;
        }
    }

    const onCustomCheckBoxChange = (customCheckboxText) => {
        setCustomCheckboxText(customCheckboxText);
    };

    return (
        <div>
            {/* loop the ticket types */}
            <>
                <Header />

                {resources && (
                    <div className="container pt-0 wrapper-smaller">

                        <div className="row mt-5">
                            <div className="col-md-12">
                                {resources.HomeIam}
                            </div>
                        </div>

                        {/* I am - radiobutton group */}
                        <div className="row">
                            <div className="col-md-4 mt-2">
                                <label className="d-flex align-items-center radio-custom" style={{ cursor: "pointer" }}>
                                    <input
                                        type="radio"
                                        name="iam"
                                        value={resources?.HomeIam1}
                                        checked={selectedIam === resources?.HomeIam1}
                                        onChange={() => setSelectedIam(resources?.HomeIam1)}
                                        className="d-none"
                                    />
                                    <span className="radio-icon me-2">
                                        <i className="bi bi-circle radio-circle"></i>
                                        {selectedIam === resources?.HomeIam1 && <i className="bi bi-check-lg radio-check"></i>}
                                    </span>
                                    <div className="d-flex flex-column">
                                        <span>{resources?.HomeIam1}</span>
                                        <small className="text-muted blue">{resources?.HomeIam1Description}</small>
                                    </div>
                                </label>
                            </div>

                            <div className="col-md-4 mt-2">
                                <label className="d-flex align-items-center radio-custom" style={{ cursor: "pointer" }}>
                                    <input
                                        type="radio"
                                        name="iam"
                                        value={resources?.HomeIam2}
                                        checked={selectedIam === resources?.HomeIam2}
                                        onChange={() => setSelectedIam(resources?.HomeIam2)}
                                        className="d-none"
                                    />
                                    <span className="radio-icon me-2">
                                        <i className="bi bi-circle radio-circle"></i>
                                        {selectedIam === resources?.HomeIam2 && <i className="bi bi-check-lg radio-check"></i>}
                                    </span>
                                    <div className="d-flex flex-column">
                                        <span>{resources?.HomeIam2}</span>
                                        <small className="text-muted blue">{resources?.HomeIam2Description}</small>
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div className="row mt-0 mt-md-2">
                            <div className="col-md-4 mt-2">
                                <label className="d-flex align-items-center radio-custom" style={{ cursor: "pointer" }}>
                                    <input
                                        type="radio"
                                        name="iam"
                                        value={resources?.HomeIam3}
                                        checked={selectedIam === resources?.HomeIam3}
                                        onChange={() => setSelectedIam(resources?.HomeIam3)}
                                        className="d-none"
                                    />
                                    <span className="radio-icon me-2">
                                        <i className="bi bi-circle radio-circle"></i>
                                        {selectedIam === resources?.HomeIam3 && <i className="bi bi-check-lg radio-check"></i>}
                                    </span>
                                    <div className="d-flex flex-column">
                                        <span>{resources?.HomeIam3}</span>
                                        <small className="text-muted blue">{resources?.HomeIam3Description}</small>
                                    </div>
                                </label>
                            </div>

                            <div className="col-md-4 mt-2">
                                <label className="d-flex align-items-center radio-custom" style={{ cursor: "pointer" }}>
                                    <input
                                        type="radio"
                                        name="iam"
                                        value={resources?.HomeIam4}
                                        checked={selectedIam === resources?.HomeIam4}
                                        onChange={() => setSelectedIam(resources?.HomeIam4)}
                                        className="d-none"
                                    />
                                    <span className="radio-icon me-2">
                                        <i className="bi bi-circle radio-circle"></i>
                                        {selectedIam === resources?.HomeIam4 && <i className="bi bi-check-lg radio-check"></i>}
                                    </span>
                                    <div className="d-flex flex-column">
                                        <span>{resources?.HomeIam4}</span>
                                        <small className="text-muted blue">{resources?.HomeIam4Description}</small>
                                    </div>
                                </label>
                            </div>
                        </div>

                        {/* Start up: access request - Only show when HomeIam3 is selected */}
                        {selectedIam === resources?.HomeIam3 && (
                            <div className="row mt-5">
                                <div className="col-md-5 mt-2">
                                    <span className="font-size-14">Are you a startup or the founder of an early-stage startup that has been operating for
                                        less than three years and don't have a promo code yet?</span>
                                </div>
                                <div className="col-md-4 mt-2">
                                    <button
                                        className="btn btn-custom-dark-red ps-4 pe-4"
                                        onClick={() => window.open('mailto:info@fuw-forum.ch', '_blank')}
                                    >
                                        Apply for Startup Access
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Media: access request - Only show when HomeIam4 is selected */}
                        {selectedIam === resources?.HomeIam4 && (
                            <div className="row mt-5">
                                <div className="col-md-5 mt-2">
                                    <span className="font-size-14">Are you a media representative but don't have a promo code yet?</span>
                                </div>
                                <div className="col-md-4 mt-2">
                                    <button
                                        className="btn btn-custom-dark-red ps-4 pe-4"
                                        onClick={() => window.open('mailto:info@fuw-forum.ch', '_blank')}
                                    >
                                        INQUIRE ACCREDITATION
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Promotion code */}
                        <div className="row mt-5">
                            <div className="col-md-12">
                                <span className="title">ENTER PROMO CODE</span><br />
                                <small className="text-muted red">Once a promo code is applied, the ticket will be unlocked accordingly.</small>
                            </div>
                            <div className="col-7 col-md-6 mt-2">
                                <input
                                    id="inputCode"
                                    type="text"
                                    name="promotionCode"
                                    className="form-control custom-textbox"
                                    onChange={(e) => {
                                        setPromoCode(e.currentTarget.value);
                                        setPromoError("");
                                        setPromoSuccess("");
                                    }}
                                    value={promoCode}
                                />
                            </div>
                            <div className="col-5 col-md-2 mt-2">
                                <button className="btn btn-custom-blue" onClick={applyPromotionCode} disabled={promoCode === ""}>
                                    {resources.HomeRendeem}
                                </button>
                            </div>
                        </div>

                        {promoError && (
                            <div className="row mt-3">
                                <div className="col-md-6">
                                    <div className="alert alert-danger" role="alert">
                                        <i className="bi bi-exclamation-circle-fill me-2"></i>
                                        {promoError}
                                    </div>
                                </div>
                            </div>
                        )}

                        {promoSuccess && (
                            <div className="row mt-3">
                                <div className="col-md-6">
                                    <div className="alert alert-success" role="alert">
                                        <i className="bi bi-check-circle-fill me-2"></i>
                                        {promoSuccess}
                                    </div>
                                </div>
                            </div>
                        )}

                        {mapTicketsTypes()}

                        {remarks?.CustomCheckboxText && (
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="float-end position-relative mt-4 pe-3 pb-4">
                                        <div className="col-md-12 float-end">
                                            <label htmlFor="chkCustomCheckboxText" className="me-3 lblAgreement">{remarks?.CustomCheckboxText}</label>
                                            <input id="chkCustomCheckboxText" type="checkbox" className="checkboxAgreement form-check-input" checked={customCheckboxText} onChange={() => onCustomCheckBoxChange(!customCheckboxText)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className={`row pt-3`}>
                            {remarks?.CustomHomepageText && (
                                <div className="col-md-12">
                                    <span dangerouslySetInnerHTML={{ __html: remarks?.CustomHomepageText }}></span>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                <div className="container wrapper">
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <Footer language={language} />
                        </div>
                    </div>
                </div>
            </>
        </div>
    );
};

export default Home;